<div class="container padding0 margin-top30 padding-bot-400">
  <div>
    <ae-general-info-tabs
      [pageName]="'Additional'"
      [summarySitecoreData]="summaryContent"
      [summaryApiData]="summaryPanel"
      style="width: 100%;"
    ></ae-general-info-tabs>
  </div>
  <div class="row">
    <div class="col-12 col-md-3">
      <accordion
        [options]="options"
        [menus]="menus"
        [additional]="true"
      ></accordion>
    </div>
    <div class="col-12 col-md-9" style="position: relative; padding-left:20px">
      <form [formGroup]="ucmFormGroup">
        <form-renderer
          *ngIf="isFormRendered"
          [formJson]="formJson"
          [showDebugConsoleMessages]="showDebugConsoleMessages"
          [apiEndpoint]="apiEndpoint"
          [apiKey]="apiKey"
          [elementDefaults]="elementDefaults"
          (formEvents)="onFormEvent($event)"
        >
        </form-renderer>
      </form>
    </div>
  </div>
</div>
